import { createSlice } from '@reduxjs/toolkit';
import { fetchAnalyticsThunk, refreshAnalyticsThunk, } from './analyticsThunks';
// ===== INITIAL STATE =====
const initialState = {
    data: null,
    isLoading: false,
    error: null,
    lastUpdated: null,
};
// ===== ANALYTICS SLICE =====
export const analyticsSlice = createSlice({
    name: 'analytics',
    initialState,
    reducers: {
        // Clear error
        clearError: (state) => {
            state.error = null;
        },
        // Set loading state
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        },
        // Set analytics data directly (for mock data)
        setAnalyticsData: (state, action) => {
            state.data = action.payload;
            state.lastUpdated = new Date().toISOString();
            state.error = null;
        },
        // Clear analytics data
        clearAnalyticsData: (state) => {
            state.data = null;
            state.lastUpdated = null;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        // ===== FETCH ANALYTICS =====
        builder
            .addCase(fetchAnalyticsThunk.pending, (state) => {
            state.isLoading = true;
            state.error = null;
        })
            .addCase(fetchAnalyticsThunk.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
            state.lastUpdated = new Date().toISOString();
            state.error = null;
        })
            .addCase(fetchAnalyticsThunk.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        });
        // ===== REFRESH ANALYTICS =====
        builder
            .addCase(refreshAnalyticsThunk.pending, (state) => {
            // Don't set loading for refresh to avoid UI flicker
        })
            .addCase(refreshAnalyticsThunk.fulfilled, (state, action) => {
            state.data = action.payload;
            state.lastUpdated = new Date().toISOString();
            state.error = null;
        })
            .addCase(refreshAnalyticsThunk.rejected, (state, action) => {
            state.error = action.payload;
        });
    },
});
// ===== ACTIONS =====
export const { clearError, setLoading, setAnalyticsData, clearAnalyticsData, } = analyticsSlice.actions;
// ===== REDUCER =====
export default analyticsSlice.reducer;
